import { render } from "./SmallDialog.vue?vue&type=template&id=690a462a&scoped=true"
import script from "./SmallDialog.vue?vue&type=script&lang=js"
export * from "./SmallDialog.vue?vue&type=script&lang=js"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690a462a"]])

export default __exports__